module.exports = __webpack_public_path__ + "img/07-xxl.ee43dca.webp";